import { Component, Input } from '@angular/core';
import { NbDialogRef } from '@nebular/theme';

import { Storage, ref, uploadString, percentage, UploadTask, uploadBytesResumable } from '@angular/fire/storage';

import { environment } from '../../../../environments/environment';
import { BuildingService } from '../../../_services/building.service';
import { MissionService } from '../../../_services/mission.service';
import { ObjectService } from '../../../_services/object.service';
import { take } from 'rxjs/operators';

@Component({
    selector: 'ngx-building-edit-modal',
    templateUrl: 'building-edit-modal.component.html',
    styleUrls: ['building-edit-modal.component.scss'],
    standalone: false
})
export class BuildingEditModalComponent {

  originalModel;

  _model;
  istemplate = false
  customObject
  @Input() set model(model){
    this._model = {...model};
    this.istemplate = model.collectionPath.includes('template')
    this.originalModel = model;
  };

  @Input() languages;
  @Input() type;
  @Input() game;
  @Input() resources;
  missions;
  objects;

  currentBuildingImage;
  task:any;
  progress: any;  // Observable 0 to 100
  progressMap = {};
  loadingPictureSize = false;

  constructor(protected modalRef: NbDialogRef<BuildingEditModalComponent>,
    public buildingService: BuildingService,
    public missionService: MissionService,
    public objectService: ObjectService,
    private storage: Storage) {}

  ngOnInit(){
    this.missionService.listMissions(`games/${this.game.id}/missions`)
    .pipe(take(1))
    .subscribe(missions => {
      console.log('Missions:'+JSON.stringify(missions));
      this.missions = missions;
    });
    this.objectService.listObjects(`games/${this.game.id}/objects`)
    .pipe(take(1))
    .subscribe(objects => {
      console.log('Objects:'+JSON.stringify(objects));
      this.objects = objects;
    });
  }

  async handleFileUpdated(objectImage, lang){
    console.log('New object image is:'+objectImage);
    this.currentBuildingImage = objectImage;
    await this.saveObjectImage(lang);
  }

  async saveObjectImage(lang){
    
    const filePath = this._model.collectionPath; //`games/${this._model.gameId}/objects/`;
    let fileName = `/${this._model.id}${lang ? '_'+lang : ''}.jpg`;

    let uploadRef = ref(this.storage, filePath+fileName);

    //this.task = uploadString(uploadRef, this.currentBuildingImage, 'data_url');
    let blob = await (await fetch(this.currentBuildingImage)).blob();
    console.log('Blob:'+blob);
    this.task = uploadBytesResumable(uploadRef, blob);

    this.task.then(async () => {
      const url = 'https://storage.googleapis.com/'+environment.firebase.storageBucket+'/'+filePath+fileName;
      console.log('file uploaded to:'+url);
      if(!lang){
        this._model.pictureUrl = url;
        this._model.filePath = filePath+fileName;
        this._model.pictureLastUpdate = new Date().getTime();
        await this.buildingService.updateBuilding(this._model, {pictureUrl:this._model.pictureUrl, filePath:this._model.filePath, pictureLastUpdate: this._model.pictureLastUpdate});
        await this.readPictureSize();
        if (this._model.pictureWidth && this._model.pictureHeight) {
          await this.buildingService.updateBuilding(this._model, {
            pictureWidth: this._model.pictureWidth,
            pictureHeight: this._model.pictureHeight
          });
        }
      }
      else{
        this._model.picture[lang] = {filePath:filePath+fileName,url:url,lastUpdateDate:new Date().getTime()};
        await this.buildingService.updateBuilding(this._model, {picture:this._model.picture});
      }
      setTimeout(() => {
        delete this.progressMap['OBJECT'+(lang ? lang : '')];
      }, 1000);
    });

    // Percentage observer
    percentage(this.task).subscribe((percentage) => {
      this.progressMap['OBJECT'+(lang ? lang : '')] =  Math.round(percentage.progress);
    });
  }

  cancel() {
    this.modalRef.close();
  }

  deletePicture(lang){
    if(!lang) {
      this._model.pictureUrl = '';
      delete this._model.pictureWidth;
      delete this._model.pictureHeight;
    }
    else {
      this._model.picture[lang] = {}
    }
  }

  readPictureSize(): Promise<void> {
    if (!this._model?.pictureUrl) {
      return Promise.resolve();
    }
    this.loadingPictureSize = true;
    return new Promise((resolve) => {
      const img = new Image();
      img.onload = () => {
        this._model.pictureWidth = img.naturalWidth;
        this._model.pictureHeight = img.naturalHeight;
        this.loadingPictureSize = false;
        resolve();
      };
      img.onerror = () => {
        console.error('Failed to load building picture for size:', this._model.pictureUrl);
        this.loadingPictureSize = false;
        resolve();
      };
      img.crossOrigin = 'anonymous';
      // Bust cache so we always read the newly uploaded file
      img.src = this._model.pictureUrl + (this._model.pictureUrl.includes('?') ? '&' : '?') + 't=' + Date.now();
    });
  }

  async save() {
    //this.originalModel = this._model;
    //Object.assign(this.originalModel, this._model);
    console.log('Save object:'+JSON.stringify(this._model));
    if(this._model.id){
      await this.buildingService.updateBuilding(this._model, {...this._model});
    }
    else{
      console.log('create object:'+this._model.collectionPath);
      if(this._model.collectionPath.indexOf('games/')>=0){
        this._model.scope = 'game';
      }
      await this.buildingService.addBuilding(this._model); 
    }
    this.modalRef.close(this.originalModel);
  }
}
